<section
  class="standard-margins m-y-64 flex flex-column flex-align-center gap-64"
>
  <header class="text-center">
    <img src="assets/404.gif" alt="Content not found" />
    <h1 class="heading-md lg:heading-lg m-t-24" i18n="@@notFoundMessage">
      The page you're looking for
      <br />
      doesn't exist.
    </h1>
    <p class="m-t-12 text-md text-secondary">
      <ng-container *ngIf="channel$ | async">
        <span i18n="@@notFoundScoped">
          Please check the address you typed. If everything
          <br />
          looks fine then probably the page was deleted.
        </span>
        <br />
      </ng-container>
      <span i18n="@@notFoundErrorCode">Error code 404.</span>
    </p>
  </header>
</section>
